import React from "react";
import { useDownloadModal } from "../contexts/DownloadModalContext";

export default function DownloadModal() {
  const { isOpen, progress } = useDownloadModal();
  if (!isOpen) return null;

  return (
    <div
      className={`
        fixed bottom-4 right-4 w-full max-w-lg bg-tier-primary dark:bg-tier-primary-dark dark:border-gray-600 border text-color p-4 rounded shadow-lg z-50
        transform transition-all duration-300 ease-out
        ${isOpen ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
      `}
    >
      <p className="text-sm mb-2">Downloading invoices...</p>

      <div className="w-full h-6 bg-gray-200 rounded-full border border-tier-secondary overflow-hidden relative">
        <div
          className="h-full bg-tier-secondary rounded-full transition-[width] duration-500 ease-linear"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}
